import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const TestPrinterDropdown = () => {
  const [printerOptions, setPrinterOptions] = useState([
    { value: '1', label: 'PM-246S', description: 'PM-246S' },
    { value: '2', label: 'STATION 1 4x6', description: 'STATION 1 4x6' }
  ]);
  const [selectedPrinter, setSelectedPrinter] = useState(null);

  const handlePrinterChange = (selectedOption) => {
    console.log('Printer selected:', selectedOption);
    setSelectedPrinter(selectedOption);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '38px',
      border: '1px solid #ddd',
      boxShadow: 'none',
      '&:hover': {
        border: '1px solid #888',
      }
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
      color: '#333',
      padding: '8px 12px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999
    })
  };

  const CustomOption = ({ innerProps, label, data, isFocused }) => (
    <div 
      {...innerProps}
      style={{
        backgroundColor: isFocused ? '#f0f0f0' : 'white',
        padding: '8px 12px',
        cursor: 'pointer'
      }}
    >
      <div>{data.label}</div>
      {data.description && data.description !== data.label && (
        <div style={{ fontSize: '0.8rem', color: '#666' }}>
          {data.description}
        </div>
      )}
    </div>
  );

  return (
    <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
      <h1>Printer Dropdown Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>Select a printer:</label>
        <Select
          value={selectedPrinter}
          onChange={handlePrinterChange}
          options={printerOptions}
          styles={customStyles}
          components={{ Option: CustomOption }}
          placeholder="Select a printer..."
          isClearable
        />
      </div>
      
      {selectedPrinter && (
        <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
          <h3>Selected Printer:</h3>
          <p>ID: {selectedPrinter.value}</p>
          <p>Name: {selectedPrinter.label}</p>
          <p>Description: {selectedPrinter.description}</p>
        </div>
      )}
    </div>
  );
};

export default TestPrinterDropdown; 